import React, { Component } from 'react';
import loadScripts  from '../../../dassets/js/custom';
import { Link } from 'react-router-dom';

class FundManagement extends Component {
  componentDidMount(){
    loadScripts();
  }
  render() {
    return (
      <>
      {/* =================================
    Inner Header */}
    <div className="inner-header bg-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
            <h1 className="breadcrumb-title mb-0">Fund Management</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
              <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
              <li className="breadcrumb-item"><span>Services</span></li>
              <li className="breadcrumb-item active"><span>Fund Management</span></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  {/* =================================
  Inner Header */}
  
  
  <section className="space-ptb">
    <div className="container">
      <div className="row">
        <div className="col-md-4 col-xl-3">
          <ul className="list-unstyled vertical-menu border border-2 rounded p-3">
                  <li><Link to={"/services/issuing-house"}><span>Issuing House</span></Link></li>
                  <li><Link to={"/services/stockbroking"}><span>Stockbroking</span></Link></li>
                  <li><Link to={"/services/financial-advisory"}><span>Financial Advisory</span></Link></li>
                  <li><Link to={"/services/portfolio-management"}><span>Portfolio Management</span></Link></li>
                  <li><Link className="active" to={"/services/fund-management"}><span>Fund Management</span></Link></li>
                  <li><Link to={"/services/lagos-commodities-and-future-exchange"}><span>Lagos Commodities and Future Exchange</span></Link></li>
          </ul>
          <div className="bg-dark rounded p-4 mb-md-0 mb-5">
            <span className="lead text-primary fw-bold">Do you have a question? Please contact us</span>
            <h6 className="text-white mt-3">+(234) 0805 555 0606</h6>
            <span className="text-white">info@dynamicportfolio.com</span>
          </div>
        </div>
        <div className="col-md-8 col-xl-9">
          {/* <img className="img-fluid mb-4" src={require("./../../dassets/images/service/10.jpg")} alt=""/> */}
          <div className="mb-md-5 mb-4">
            <h4 className="mb-4">Fund Management</h4>
            <div className='mb-4'>
                  <p>Our approach to Fund Management is to structure out a balanced investment in consonance with the intention of the fund and to meet the characteristics of the fund. Specifically the fund's investment will be reviewed to guarantee a minimum level of return. The fund shall be invested in the capital and/or money markets. The maturity profile will be synchronized with the anticipated drawdown on the fund. These feats will be accomplished in agreement with the fund trustees. The management could either be on discretionary or non-discretionary basis. Discretionary implies that decisions on investment will be at the behest of the fund trustees upon our advice/suggestions. While non-discretionary implies that absolute decision on investment lies with us subject to an agreed minimum return.</p>

                  <p><strong>Reports:</strong> This shall be rendered on quarterly basis. It will contain report of performances and suggestions for future investments.</p>
                  </div>
          </div>
        </div>
      </div>
    </div>
  </section>
      </>
    );
  }
}

export default FundManagement;